import { Site } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import RawInput from '@swf/components/Inputs/RawInput';
import { Country as CountryEnum } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { FieldNameProp } from '@swf/core/types/Props';
import { required } from '@swf/core/utils/validators';

import { findCountry } from '../CountrySelect/CountrySelect';
import RMFDropDown from '../RMF/components/RMFDropDown/RMFDropDown';
import { label, root } from '../TextInput/TextInput.scss';

import { TXTCLI_Country } from './Country.messages.json';
import { getCountries } from './getCountries';

interface Props extends FieldNameProp {
  country: string;
  labelClassName?: string;
  labelContent?: React.ReactNode;
  className?: string;
  isRmfFlow?: boolean;
}

const ukCountries = [
  CountryEnum.GreatBritain,
  CountryEnum.Jersey,
  CountryEnum.Gibraltar,
  CountryEnum.Guernsey
];

const isUKCountry = (country: string | CountryEnum): boolean =>
  ukCountries.includes(country as CountryEnum);

const Country: React.FC<Props> = ({
  country,
  fieldName,
  labelClassName,
  labelContent,
  className,
  isRmfFlow
}) => {
  const site = useSelector(select.cms.getSiteId);
  const countries = getCountries(site, country);

  return isRmfFlow && (isUKCountry(country) || site === Site.ES) ? (
    <RMFDropDown
      id={fieldName}
      label={TXTCLI_Country}
      options={countries}
      validators={[required(null)]}
      className={classNames(root, className)}
    />
  ) : (
    <RawInput
      id={fieldName}
      label={TXTCLI_Country}
      labelClassName={classNames(label, labelClassName)}
      labelContent={labelContent}
      rawValue={findCountry(country)?.text || ''}
      className={classNames(root, className)}
      disabled
    />
  );
};

export default Country;
